import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  getCollegeList,
  getStudentListByCollege,
  getMentorsListByCollege,
  getAgivantMentorsList,
  createTeam,
  saveProject,
  fetchProjects,
  deleteProjectById,
  saveMentorIdTeamId,
} from "../../../services/studentportalapis"; // Import createTeam function

const AddProject = () => {
  const [projects, setProjects] = useState([]);
  const [students, setStudents] = useState([]);
  const [mentors, setMentors] = useState([]);
  const [agivantMentors, setAgivantMentors] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectedMentors, setSelectedMentors] = useState([]);
  const [selectedAgivantMentors, setSelectedAgivantMentors] = useState([]);
  const [projectTitle, setProjectName] = useState("");
  const [teamName, setTeamName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [colleges, setColleges] = useState([]);
  const [selectedCollege, setSelectedCollege] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showForm, setShowForm] = useState(false);

  const fetchProject = async () => {
    try {
      const data = await fetchProjects();

      console.log("projects :", data);
      setProjects(data);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  useEffect(() => {
    fetchProject();
  }, []);

  const fetchColleges = async () => {
    try {
      const data = await getCollegeList();
      console.log("college list: ", data);
      setColleges(data);
    } catch (error) {
      console.error("Error fetching colleges:", error);
    }
  };

  useEffect(() => {
    fetchColleges();
  }, []);

  useEffect(() => {
    fetchMentorsByCollege();
    fetchAgivantMentors();
  }, []);

  const fetchStudentsByCollege = async (collegeId) => {
    try {
      const data = await getStudentListByCollege(collegeId);
      console.log("college students", data);
      const studentOptions = data.map((student) => ({
        value: student.studentId,
        label: `${student.firstName} ${student.lastName}`,
      }));
      console.log("students: ", studentOptions);
      setStudents(studentOptions);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  const fetchMentorsByCollege = async (collegeId) => {
    try {
      const data = await getMentorsListByCollege(collegeId);
      const mentorOptions = data.map((mentor) => ({
        value: mentor.mentorEmail,
        label: mentor.mentorName,
        mentorData: mentor, // Store the full mentor data here
      }));
      console.log("mentors :", data);
      setMentors(mentorOptions);
    } catch (error) {
      console.error("Error fetching mentors:", error);
    }
  };

  const fetchAgivantMentors = async () => {
    try {
      const data = await getAgivantMentorsList();
      const mentorOptions = data.map((mentor) => ({
        value: mentor.mentorEmail,
        label: mentor.mentorName,
        mentorData: mentor, // Store the full mentor data here
      }));
      console.log("agivant mentors :", data);
      setAgivantMentors(mentorOptions);
    } catch (error) {
      console.error("Error fetching mentors:", error);
    }
  };

  const deleteProject = async (projectId) => {
    try {
      await deleteProjectById(projectId);

      // Refresh the page after successful deletion
      window.location.reload();

      // Optionally, show success message
      alert("Project deleted successfully!");
    } catch (error) {
      console.error("Error deleting project:", error);
      alert("Failed to delete the project. Please try again.");
    }
  };

  const handleCollegeChange = (e) => {
    const collegeId = e.target.value;
    setSelectedCollege(collegeId);
    fetchStudentsByCollege(collegeId);
    fetchMentorsByCollege(collegeId);
  };

  // const handleMentorChange = (e) => {
  //   const collegeId = e.target.value;
  //   setSelectedMentors(collegeId);
  //   fetchMentorsByCollege(collegeId);
  // };

  const createTeamAndProject = async () => {
    if (
      !projectTitle ||
      !teamName ||
      !startDate ||
      !endDate ||
      selectedStudents.length === 0 ||
      !selectedCollege ||
      selectedMentors.length === 0
    ) {
      alert(
        "Please fill all fields and select at least one student and mentor."
      );
      return;
    }

    try {
      // Create the team
      const teamResponse = await createTeam(
        teamName,
        selectedStudents.map((student) => student.value)
      );
      console.log("Team created successfully:", teamResponse);

      const teamId = teamResponse.teamId;

      // for (let mentor of selectedMentors) {
      //   console.log("mentorId :",mentor.mentorData.mentorId)
      //   const mentorId = mentor.mentorData.mentorId;
      //   await saveMentorIdTeamId(teamId,mentorId);

      // }

      // for (let mentor of selectedMentors) {
      //   console.log("mentorId :", mentor.mentorData.mentorId);
      //   const mentorId = mentor.mentorData.mentorId;
      //   for (let agivantMentor of selectedAgivantMentors) {
      //     const agivantMentorId = agivantMentor.mentorData.agivant_mentor_id;
      //     console.log("Agivant Mentor ID:", agivantMentor.mentorData);
      //     console.log("Agivant Mentor ID:", agivantMentorId);
      //     console.log("Agivant Mentor ID type:", typeof agivantMentorId);
      //     await saveMentorIdTeamId(teamId, mentorId, agivantMentorId); // Single API call
      //   }
      // }

      for (let i = 0; i < selectedMentors.length; i++) {
        const mentor = selectedMentors[i];
        const mentorId = mentor.mentorData.mentorId;
      
        // Only pair mentor with Agivant mentor by index
        if (i < selectedAgivantMentors.length) {
          const agivantMentor = selectedAgivantMentors[i];
          const agivantMentorId = agivantMentor.mentorData.agivant_mentor_id;
          console.log("Pairing mentorId:", mentorId, "with agivantMentorId:", agivantMentorId);
          await saveMentorIdTeamId(teamId, mentorId, agivantMentorId); // Single API call
        }
      }
      

      // Prepare project details
      const newProject = {
        projectTitle,
        startDate,
        endDate,
        collegeId: selectedCollege,
        team: { teamId },
      };

      // Save the project
      const createdProject = await saveProject(newProject);
      console.log("Project created successfully:", createdProject);

      setProjects((prevProjects) => [...prevProjects, createdProject]);
      alert("Mentor and project created successfully!");
      resetForm();
    } catch (error) {
      console.error("Error creating mentor or project:", error);
      alert("Failed to save mentor or create project. Please try again.");
    }
  };

  const resetForm = () => {
    setProjectName("");
    setTeamName("");
    setStartDate("");
    setEndDate("");
    setSelectedStudents([]);
    setSelectedMentors([]);
    setSelectedCollege("");
    setShowForm(false);
  };

  const filteredProjects = projects.filter((project) =>
    project.projectTitle.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="container mx-auto p-8 bg-gray-50 min-h-screen">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-8">
        Projects Management
      </h1>

      {!showForm && (
        <button
          onClick={() => setShowForm(true)}
          className="bg-blue-600 text-white p-3 rounded-lg mb-8 hover:bg-blue-700 transition"
        >
          Create New Project
        </button>
      )}

      {showForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div
            className="relative bg-white rounded-lg shadow-lg max-w-4xl w-full max-h-[85vh] overflow-auto scrollbar-hide
            [&::-webkit-scrollbar]:[width:10px]
            [&::-webkit-scrollbar-thumb]:bg-transparent
            [&::-webkit-scrollbar-thumb]:[border-radius:10px]
            overflow-x-hidden"
          >
            <div className="flex-1">
              <div className="flex items-center justify-between px-6 py-2 rounded-t-lg">
                <div className="text-xl font-bold text-gray-800 mb-4 text-center ">
                  Create a New Project
                </div>
                <button
                  onClick={() => setShowForm(false)}
                  className="bg-transparent text-blue-900 text-2xl"
                >
                  &times;
                </button>
              </div>

              <div className="mb-4 px-6">
                <label className="block text-sm font-medium text-gray-700">
                  Project Name:
                </label>
                <input
                  type="text"
                  value={projectTitle}
                  onChange={(e) => setProjectName(e.target.value)}
                  className="w-full p-3 border text-sm border-gray-300 rounded-lg"
                  placeholder="Enter project name"
                />
              </div>

              <div className="mb-4 flex gap-6 px-6">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Start Date:
                  </label>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="w-full p-3 text-sm border border-gray-300 rounded-lg"
                  />
                </div>

                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700">
                    End Date:
                  </label>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="w-full p-3 text-sm border border-gray-300 rounded-lg"
                  />
                </div>
              </div>

              <div className="mb-4 flex gap-6 px-6">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Select College:
                  </label>
                  <select
                    value={selectedCollege}
                    onChange={handleCollegeChange}
                    className="w-full p-3 border text-sm border-gray-300 rounded-lg"
                  >
                    <option value="">Select a college</option>
                    {colleges.map((college) => (
                      <option key={college.collegeId} value={college.collegeId}>
                        {college.collegeName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Team Name:
                  </label>
                  <input
                    type="text"
                    value={teamName}
                    onChange={(e) => setTeamName(e.target.value)}
                    className="w-full p-3 border text-sm border-gray-300 rounded-lg"
                    placeholder="Enter project name"
                  />
                </div>
              </div>

              <div className="mb-4 flex gap-6 px-6">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Select Mentors:
                  </label>
                  <Select
                    isMulti
                    options={mentors}
                    value={selectedMentors}
                    onChange={setSelectedMentors}
                    className="basic-multi-select text-sm"
                    classNamePrefix="select"
                    placeholder="Select Mentors"
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Select Agivant Mentors:
                  </label>
                  <Select
                    isMulti
                    options={agivantMentors}
                    value={selectedAgivantMentors}
                    onChange={setSelectedAgivantMentors}
                    className="basic-multi-select text-sm"
                    classNamePrefix="select"
                    placeholder="Select Mentors"
                  />
                </div>
              </div>

              <div className="mb-4 px-6">
                <label className="block text-sm font-medium text-gray-700">
                  Select Students:
                </label>
                <Select
                  isMulti
                  options={students}
                  value={selectedStudents}
                  onChange={setSelectedStudents}
                  className="basic-multi-select text-sm"
                  classNamePrefix="select"
                  placeholder="Select students"
                />
              </div>

              <div className="px-6">
                <button
                  onClick={createTeamAndProject}
                  className="w-full px-6 bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 transition"
                >
                  Create Project
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="mb-6">
        <input
          type="text"
          placeholder="Search projects by name"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg"
        />
      </div>

      <div className="bg-white p-6 rounded-lg shadow-lg">
        <table className="min-w-full table-auto">
          <thead>
            <tr className="border-b">
              <th className="py-3 px-4 text-left text-lg font-semibold text-gray-700">
                Project Name
              </th>
              <th className="py-3 px-4 text-left text-lg font-semibold text-gray-700">
                Start Date
              </th>
              <th className="py-3 px-4 text-left text-lg font-semibold text-gray-700">
                End Date
              </th>
              <th className="py-3 px-4 text-left text-lg font-semibold text-gray-700">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredProjects.map((project) => (
              <tr key={project.projectId} className="border-b">
                <td className="py-3 px-4 text-lg text-gray-800">
                  {project.projectTitle}
                </td>
                <td className="py-3 px-4 text-lg text-gray-800">
                  {project.startDate}
                </td>
                <td className="py-3 px-4 text-lg text-gray-800">
                  {project.endDate}
                </td>
                <button
                  onClick={() => deleteProject(project.projectId)}
                  className="text-red-600 hover:text-red-800 transition"
                >
                  Delete
                </button>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AddProject;
